var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4687 73.5313C38.4219 75.4844 41.5937 75.4844 43.5469 73.5313L68.5469 48.5313C70.5 46.5781 70.5 43.4062 68.5469 41.4531C66.5938 39.5 63.4219 39.5 61.4688 41.4531L45 57.9375V10C45 7.23437 42.7656 5 40 5C37.2344 5 35 7.23437 35 10V57.9219L18.5312 41.4687C16.5781 39.5156 13.4062 39.5156 11.4531 41.4687C9.5 43.4219 9.5 46.5938 11.4531 48.5469L36.4531 73.5469L36.4687 73.5313Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.5d9bbdc0abcf3b3dd931b3967ee59561.svg";
export { ForwardRef as ReactComponent };